import { GridEmptyState } from '@issuemanager/apps/client/components';
import { paths } from '@issuemanager/apps/client/paths';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { Link as MUILink, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function IssueTypesTableEmpty({
  children,
}: PropsWithChildren): React.JSX.Element {
  const { t } = useTranslation(['common', 'settings']);
  const semantic = useAtlasSemanticThemeTokens();

  return (
    <GridEmptyState>
      <Stack
        direction='column'
        justifyContent='start'
        alignItems='center'
        spacing={1.5}
        height='100%'
        data-testid='issue-types-empty-state'
      >
        <Stack spacing={1} alignItems='center'>
          <Typography fontWeight='medium'>{t('common:table.empty')}</Typography>
          {children}
        </Stack>
        <Stack spacing={1} alignItems='center'>
          <Typography
            fontWeight='medium'
            color={semantic.color.text.muted.value}
          >
            {`${t('settings:issueTypes.table.empty.click')} `}
            <MUILink
              sx={{ pointerEvents: 'auto' }}
              to={`/${paths.issueTypes.add}`}
              component={Link}
            >
              {t('settings:issueTypes.form.actions.addSubtype')}
            </MUILink>
            {` ${t('settings:issueTypes.table.empty.toStart')}`}
          </Typography>
          {children}
        </Stack>
      </Stack>
    </GridEmptyState>
  );
}
